export enum ECustomerStatus {
  /** 待认证 */
  AWAIT_AUTH = '001',
  /** 待审核 */
  AWAIT_APPROVAL = '002',
  /** 认证中 */
  AUTH_ING = '003',
  /** 已认证 */
  AUTH_ED = '004',
  /** 已驳回 */
  DISMISSED = '100',
  /** 已禁用 */
  DISABLED = '101',
}

/** 客户公司状态映射 */
export const customerStatusMap: ReadonlyMap<ECustomerStatus, string> = new Map([
  [ECustomerStatus.AWAIT_AUTH, '待认证'],
  [ECustomerStatus.AWAIT_APPROVAL, '待审核'],
  [ECustomerStatus.AUTH_ING, '认证中'],
  [ECustomerStatus.DISMISSED, '已驳回'],
  [ECustomerStatus.DISABLED, '已禁用'],
  [ECustomerStatus.AUTH_ED, '已认证'],
]);

/** 手机号操作类型 */
export enum EPhoneOperation {
  /** 解绑 */
  UNBIND = 0,
  /** 绑定 */
  BIND = 1,
}

export const phoneOperationMap: ReadonlyMap<EPhoneOperation, string> = new Map([
  [EPhoneOperation.UNBIND, '解绑'],
  [EPhoneOperation.BIND, '绑定'],
]);

export enum ESignType {
  /** 企业用户 */
  ENTERPRISE = 20,
  /** 个人用户 */
  PERSONAL = 10,
}

export const signTypeMap: ReadonlyMap<ESignType, string> = new Map([
  [ESignType.ENTERPRISE, '企业用户'],
  [ESignType.PERSONAL, '个人用户'],
]);
